import { Trash, Barcode } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

export default function PurchasesTable({ purchases, onDelete }) {
  return (
    <div className="border rounded-md mt-6">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Fecha</TableHead>
            <TableHead>Artículo</TableHead>
            <TableHead>Código</TableHead>
            <TableHead>Categoría</TableHead>
            <TableHead className="text-right">Cantidad</TableHead>
            <TableHead className="text-right">Precio Unit.</TableHead>
            <TableHead className="text-right">Total</TableHead>
            <TableHead></TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {purchases.length === 0 ? (
            <TableRow>
              <TableCell colSpan={8} className="text-center text-slate-500 py-8">
                No hay compras registradas
              </TableCell>
            </TableRow>
          ) : (
            purchases.map((purchase) => (
              <TableRow key={purchase.id} className="table-row">
                <TableCell>{purchase.fecha}</TableCell>
                <TableCell className="font-medium">{purchase.articulo}</TableCell>
                <TableCell>
                  {purchase.codigo_barras ? (
                    <span className="flex items-center gap-1 text-xs text-slate-500 font-mono">
                      <Barcode size={14} />
                      {purchase.codigo_barras}
                    </span>
                  ) : (
                    <span className="text-slate-300">-</span>
                  )}
                </TableCell>
                <TableCell>
                  <Badge variant="secondary" className="text-xs">
                    {purchase.categoria || "Otros"}
                  </Badge>
                </TableCell>
                <TableCell className="text-right">{purchase.cantidad}</TableCell>
                <TableCell className="text-right">{purchase.precio_articulo.toFixed(2)}€</TableCell>
                <TableCell className="text-right font-semibold">{purchase.precio_total.toFixed(2)}€</TableCell>
                <TableCell>
                  <Button
                    data-testid={`delete-purchase-${purchase.id}`}
                    variant="ghost"
                    size="sm"
                    onClick={() => onDelete(purchase.id)}
                    className="text-red-600 hover:text-red-700 hover:bg-red-50"
                  >
                    <Trash size={16} />
                  </Button>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
